import React from 'react';
import { Link } from 'react-router-dom';
import SiteProofLogo from '../../../components/SiteProofLogo';

const PrivacyPageFooter = () => {
  return (
    <footer className="bg-slate-900 border-t border-slate-800 py-8 mt-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <SiteProofLogo size="sm" />
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <Link to="/terms-of-service" className="text-xs text-slate-400 hover:text-white transition-colors">
              Terms of Service
            </Link>
            <Link to="/data-processing" className="text-xs text-slate-400 hover:text-white transition-colors">
              Data Processing Agreement
            </Link>
            <Link to="/cookie-policy" className="text-xs text-slate-400 hover:text-white transition-colors">
              Cookie Policy
            </Link>
            <Link to="/" className="text-xs text-slate-400 hover:text-white transition-colors">
              Back to SiteProof
            </Link>
          </div>
          <div className="text-center sm:text-right">
            <p className="text-xs text-slate-500">&copy; 2026 SiteProof Ltd. All rights reserved.</p>
            <p className="text-xs text-slate-600 mt-0.5">SiteProof Ltd is registered in England and Wales. Company number: 17085500.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default PrivacyPageFooter;
